import icon_gamepad from "../assets/icon_gamepad.png";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";
import { useContext } from "react";

function Header() {
  let navigate = useNavigate();
  const { setAuthState } = useContext(AuthContext);

  const logout = () => {
    localStorage.removeItem("accessToken");
    setAuthState({ username: "", id: 0, status: false });
    navigate("/");
  };

  return (
    <div className="Header">
      <img src={icon_gamepad} alt="icon_gamepad" />
      <h1>VerbalVortex</h1>

      <ul>
        <Link to="/newParty" className="Link">
          <li>New Party</li>
        </Link>
        <Link to="/rules" className="Link">
          <li>Rules</li>
        </Link>
        <Link to="/friends" className="Link">
          <li>Friends</li>
        </Link>
        <Link to="/globalRanking" className="Link">
          <li>Global Ranking</li>
        </Link>
        <li style={{ cursor: "pointer" }} onClick={logout}>
          Logout
        </li>
      </ul>
    </div>
  );
}

export default Header;
